module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/36fcc7dbca20720abcab01e49d4955f9.svg";